import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { SeasonSelectorService } from '../../../../_shared/components/season-selector/season-selector.service';
import { Season } from '../../../../_shared/models/season.model';
import { Tie } from '../../../../_shared/models/tie.model';
import { DownloadTieService } from './download-tie.service';
import { LeagueService } from '../../../../leagues/league.service';
import { ToastService } from '../../../../_core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
    selector: 'app-download-tie',
    templateUrl: './download-tie.component.html',
    styleUrls: ['./download-tie.component.scss'],
})
export class DownloadTieComponent implements OnInit, OnDestroy {
    private leagueService = inject(LeagueService)
    private toastService = inject(ToastService)
    private translateService = inject(TranslateService)
    @Input() tieId: string;
    @Input() _tieId: string;
    @Input() templateSubtype: string;
    @Input() leagueId: string;
    @Input() isLeagueOwner: boolean;
    @Input() partner: string;
    season: Season;
    isLoading: boolean;

    private destroyed$: Subject<void> = new Subject();

    constructor(
        private downloadTieService: DownloadTieService,
        private seasonSelectorService: SeasonSelectorService
    ) { }

    ngOnInit() {
        this.season = this.seasonSelectorService.season;
        this.subscriptions()
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    getTie () {
        this._tieId
            ? this.addTieToLeague()
            : this.downloadTie()
    }

    downloadTie() {
        this.isLoading = true;
        const timezoneOffset = new Date().getTimezoneOffset();
        this.downloadTieService
            .download(this.tieId, this.templateSubtype, this.partner, timezoneOffset, this.season?.seasonId, this.leagueId)
            .pipe(
                takeUntil(this.destroyed$),
                finalize(() => this.isLoading = false)
            )
            .subscribe(
                res => {
                    this.downloadTieService.publishDownloadedTie(res.data.tie);
                    this.toastService.presentToast(this.translateService.instant('Team match is added to the league successfully'))
                }
            );
    }

    private addTieToLeague() {
        this.leagueService.addTiesToLeague(this.leagueId, [this._tieId])
            .subscribe(
                res => {
                    this.toastService.presentToast(this.translateService.instant('Team match is added to the league successfully'))
                }
            )
    }

    private subscriptions() {
        this.seasonSelectorService
            .subscribeSelectedSeason()
            .pipe(
                takeUntil(this.destroyed$),
            )
            .subscribe(
                (season: Season) => {
                    this.season = season;
                }
            )
    }

}
